import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ValidationPageContainer} from '../ValidationProcess/style';

interface ValidationProcessProps {
  color?: string;
  style?: React.CSSProperties
  success?: boolean;
  callbackUrl?: string;
  username?: string | null;
  operationId?: string;
  operationGuid?: string;
}

const ValidationProcessCompleted = ({
                                      color = "#666",
                                      style,
                                      success,
                                      callbackUrl,
                                      username,
                                      operationId,
                                      operationGuid
                                    }: ValidationProcessProps) => {
  const {t} = useTranslation();

  function RedirectToCallbackUrl() {
    useEffect(() => {

      const timeout = setTimeout(() => {
        if (callbackUrl) {
          if (callbackUrl?.indexOf("{{username}}") && username)
            callbackUrl = callbackUrl?.replace("{{username}}", username);
          if (callbackUrl?.indexOf("{{operationId}}") && operationId)
            callbackUrl = callbackUrl?.replace("{{operationId}}", operationId);
          if (callbackUrl?.indexOf("{{operationGuid}}") && operationGuid)
            callbackUrl = callbackUrl?.replace("{{operationGuid}}", operationGuid);

          console.log("redirects to " + callbackUrl);
          // 👇️ redirects to an external URL
          window.location.assign(callbackUrl);
        }
      }, 3000);

      return () => clearTimeout(timeout);
    }, []);

    return <>Will redirect in 3 seconds...</>;
  }

  return (
    <ValidationPageContainer color={color} data-testid="validationprocesscompleted" style={{...style}}>
      {success ? (
        <>
          <div className="verificationSuccess">
            <img src={'/assets/img/emoji-success.svg'} alt=""/>
            <h3>{t('verifications.complete.success.title')}</h3>
            <p><strong>{t('verifications.complete.success.description')}</strong></p>
            <p><strong>{t('verifications.complete.success.disclaimer')}</strong></p>
          </div>
          {callbackUrl ? (<RedirectToCallbackUrl/>) : null}
        </>
      ) : (
        <div className="verificationFail">
          <h3>{t('verifications.complete.fail.title')}</h3>
          <p>{t('verifications.complete.fail.description')}</p>
          <p><strong>{t('verifications.complete.fail.contact')}</strong></p>
          <img src={'/assets/img/error-notexist.svg'} alt=""/>
        </div>
      )
      }
    </ValidationPageContainer>
  );
};

export default ValidationProcessCompleted;
